import { render, staticRenderFns } from "./broadcastRoom.vue?vue&type=template&id=085f736f&scoped=true"
import script from "./broadcastRoom.vue?vue&type=script&lang=js"
export * from "./broadcastRoom.vue?vue&type=script&lang=js"
import style0 from "./broadcastRoom.vue?vue&type=style&index=0&id=085f736f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085f736f",
  null
  
)

export default component.exports